var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._t("default",null,{"loading":_vm.loading,"errors":_vm.errors,"ItemForm":_vm.ItemForm,"submit":_vm.submit})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }